{
  "activeMiners": "活跃矿工",
  "approvedRewards": "已批准奖励",
  "assetOverview": "账户与资产",
  "buyExalt": "购买 EXALT",
  "community": "社区",
  "dashboardSubtitle": "专业数字资产交易平台",
  "dashboardTitle": "仪表盘",
  "displayCurrency": "显示货币",
  "earn": "赚取",
  "estimatedExchangeWalletValue": "交易所钱包预估价值",
  "exchangeActivity": "交易所动态",
  "hideBalances": "隐藏余额",
  "leaderboard": "排行榜",
  "live": "实时",
  "liveMarketBoard": "● 实时市场看板",
  "loading": "加载中...",
  "marketCap": "市值",
  "marketStatus": "市场状态",
  "miningPool": "矿池",
  "noActivityYet": "暂无动态",
  "notifications": "通知",
  "pendingRewards": "待处理奖励",
  "portfolioValue": "资产组合价值",
  "quickActions": "快捷操作",
  "readyTradingWithdrawal": "可用于交易或提现",
  "recentActivity": "最近动态",
  "recentOrders": "最近订单",
  "refresh": "刷新",
  "refreshDashboard": "刷新仪表盘",
  "security": "安全与验证",
  "showBalances": "显示余额",
  "submitListing": "提交上币申请",
  "topGainer": "涨幅榜首",
  "topLoser": "跌幅榜首",
  "totalPortfolioValue": "资产组合总价值",
  "trendingCoins": "热门币种",
  "unavailable": "暂不可用",
  "viewMarketBoard": "查看市场看板",
  "waitingAdminApproval": "等待管理员审批",
  "walletStatus": "钱包状态"
}